<script>
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
import Swal from "sweetalert2";
import axios from "axios";

export default {
  name: "pdf-viewer",
  props: {
    fileUrl: String,
    streamPdf:Boolean,
    pageCount:Number,
    workingFile:String,
    shareId:String,
    apiEndpoint:String
  },
  components: {
    VuePdfEmbed
  },
  computed: {
    currentPageNum: function() {
      return Number(this.currentPage);
    }
  },
  mounted() {
    var canvas = document.getElementById("pdfviewercontainer");
        
    if (canvas == null || canvas == undefined) console.log("meh");
    
    this.wireTouchEvents(canvas);
    
    window.onbeforeprint = function () {
          //alert('Printing is not allowed!');
          var el = document.getElementById('pdfviewer');
          el.remove();
          
         location.reload();
      }
      
      
  },
  created() {
    for (var i = 2; i <= 100; i = i + 2) {
      this.zoomLevels.push({ value: i, text: `${i}%` });
    }
    var zoom = this.$cookie.get("zoomLevel")
    
    if (zoom != undefined) this.zoomLevel = zoom;
    
    window.onresize = function() {
      this.viewerWidth = window.innerWidth
    }
    
    this.pdfData = this.fileUrl;
    
  },
  data: function() {
    return {
      zoomLevel: "50",
      zoomPageLevel:"100",
      totalPages: 0,
      currentPage: 1,
      currentMax: 10,
      zoomLevels: [],
      pdfPages: [],
      showLoadMorePages: false,
      initialX: null,
      initialY: null,
      showAllPages: false,
      pdfData:"",
      streamedPage:1,
      isPageLoading:false
    };
  },
  watch: {
    zoomLevel: function (val){
      this.$cookie.set("zoomLevel", val, 365);
    }
  },
  methods: {
    handleDocumentRender: function() {
      this.isLoading = false
      
      if (this.streamPdf){
        this.totalPages = this.pageCount;
        //this.streamedPage = 1;
      }
      else{
        this.totalPages = this.$refs.pdfRef.pageCount
      }
      
      this.pdfPages = [];
      
      if (this.totalPages > 10 && !this.streamPdf){
        this.currentMax = 10;
        this.showLoadMorePages = true;
      }
      else{
        this.currentMax = this.totalPages;
        this.showLoadMorePages = false;
      }
      
      for (var x = 1;x <= this.currentMax;x++){
        if (x > 10) break;
        this.pdfPages.push(x);
      }
    },
    wireTouchEvents: function(container){
      container.addEventListener("touchstart", this.startTouch, false);
      container.addEventListener("touchmove", this.moveTouch, false);
      
      // Swipe Up / Down / Left / Right
     
    },
    startTouch: function (e) {
      this.initialX = e.touches[0].clientX;
      this.initialY = e.touches[0].clientY;
    },
    moveTouch: function(e) {
      if (this.initialX === null) {
        return;
      }
    
      if (this.initialY === null) {
        return;
      }
    
      var currentX = e.touches[0].clientX;
      var currentY = e.touches[0].clientY;
    
      var diffX = this.initialX - currentX;
      var diffY = this.initialY - currentY;
    
      if (Math.abs(diffX) > Math.abs(diffY)) {
        // sliding horizontally
        if (diffX > 0) {
          // swiped left
          console.log("swiped left");
          this.gotoNextPage();
        } else {
          // swiped right
          console.log("swiped right");
          this.gotoPreviousPage();
        }  
      } else {
        // sliding vertically
        if (diffY > 0) {
          // swiped up
          console.log("swiped up");
        } else {
          // swiped down
          console.log("swiped down");
        }  
      }
    
      this.initialX = null;
      this.initialY = null;
    
      e.preventDefault();
    },
    getPrevTen: function(){
      var prevTen = this.currentMax - 10;
      
      if (prevTen <= 0) prevTen = 1;
      
      this.pdfPages = [];
      
      var startPoint = prevTen - 10;
      
      for(var i = startPoint; i <= prevTen; i++){
        if (i != 0) this.pdfPages.push(i);
      }
      
      this.currentMax = prevTen;
    },
    getNextTen: function(){
      var nextTen = this.currentMax + 10;
      
      if (nextTen > this.totalPages) nextTen = this.totalPages;
      
      this.pdfPages = []
      
      for(var i = this.currentMax + 1;i <= nextTen; i++){
        this.pdfPages.push(i);
      }
      
      this.currentMax = nextTen;
    },
    goToPage: function(page){
      this.currentPage = page;
    },
    gotoAnyPage: function (pageNumber){
      if(this.streamPdf){
        this.isPageLoading = true;
        var pbody = {
           'Id':this.shareId,
           'Password':"",
           'DeviceId': "",
           'workingFile': this.workingFile,
           'pageNumber': pageNumber
         }
         
         var vm = this;
         
         axios.post(`${this.apiEndpoint}/document/getpdffromshare`, pbody)
           .then(data => {
             var result = data.data;
              
              vm.pdfData = `data:application/pdf;base64,${result.base64Data}`;
              
              
              this.isPageLoading = false;
         })
         
          this.currentPage = pageNumber;
      }
      else{
        this.currentPage = pageNumber;
      }
    },
    gotoNextPage: function() {
      if (this.currentPage < this.totalPages) {
        this.gotoAnyPage(this.currentPage + 1);
        
        this.streamedPage = this.currentPage;
      } else {
        this.gotoAnyPage(1)
        this.streamedPage = 1;
      }
    },
    gotoPreviousPage: function() {
      if (this.currentPage > 1) {
        this.gotoAnyPage(this.currentPage - 1);
        this.streamedPage= this.currentPage;
      } else {
        this.gotoAnyPage(1) 
        this.streamedPage = 1; 
      }
      
      
    },
    pageChanged: function(){
      if (this.streamPdf){
        if (this.streamedPage > this.pageCount) {this.streamedPage = this.pageCount;}
        
        this.gotoAnyPage(this.streamedPage);
      }
    },
    documentloaded: function(){
      this.pdfPages = [];
      
      if (this.totalPages > 10){
        this.currentMax = 10;
        this.showLoadMorePages = true;
      }
      else{
        this.currentMax = this.totalPages;
        this.showLoadMorePages = false;
      }
      
      for (var x = 1;x <= this.currentMax;x++){
        if (x > 10) break;
        this.pdfPages.push(x);
      }
    },
    setPassword: function(updatePassword, reason){
      Swal.fire({
        icon: 'info',
        title: 'Password Required',
        input: 'password',
        inputLabel: 'Password',
        inputPlaceholder: 'Enter the PDF password',
        showCancelButton: true,
        inputAttributes: {
          maxlength: 10,
          autocapitalize: 'off',
          autocorrect: 'off'
        }
      })
      .then((result) => {
        if (result.isConfirmed) {
          updatePassword(result.value);
        }
        else{
          return;
        }
      })
      
      console.log(reason);
    
    }
  }
};
</script>
<style>
.pdfviewer {
  border-style: solid;
  border-width: 1px;
  border-color: #ebedf3;
  border-radius: 0px;
  display: inline;
  max-height:95vh;
  box-shadow: 0 0 0 1px rgba(136,152,170,.1),0 15px 35px 0 rgba(49,49,93,.1),0 5px 15px 0 rgba(0,0,0,.08);
}
.viewercontrols{
  flex-wrap: nowrap;
  width: 100%;
  text-align: center;
  justify-content: center !important;
}
.toolbarfield {
  max-width: 100px;
}

.viewer-container{
  align-content: center;
  justify-content: center;
  margin-bottom: 20px;
}

.viewer-pages {
  margin-right: 5px;
  cursor: pointer;
  max-width: 64px;
}

.vue-pdf-embed > div {
  margin-bottom: 8px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}

@media only screen and (max-width: 700px) {
  .mobile-device {
    display: none;
  }
}
</style>
<template>
  <div style="text-align:center;">
   
    <!--this is the toolbar-->
    <b-row align-h="center" style="margin:10px" v-if="fileUrl != ''">
      
      <b-form inline class="viewercontrols">
       
        <input type="checkbox" class="mr-sm-2 mobile-device" v-model="showAllPages" name="ShowAllPages" v-if="!streamPdf"/>
        <label for="ShowAllPages" style="margin-right:25px" v-if="!streamPdf">Show All Pages</label>
        
        <label class="mr-sm-2 mobile-device" for="inline-form-custom-select-pref">Zoom</label>
        <b-form-select
          class="mb-2 mr-sm-2 mb-sm-0 toolbarfield"
          :value="55"
          :options="zoomLevels"
          id="inline-form-custom-select-pref"
          v-model="zoomLevel"
        />
        <label class="mr-sm-2 mobile-device" for="pageNumber">Go to page </label>
        <button type="button" @click="gotoPreviousPage()" class="btn" style="margin-right: 0.5rem;">
          <img src="/media/Angle-left.svg" />
        </button>
        <b-input v-if="!streamPdf"
          id="pageNumber"
          class="mb-2 mr-sm-2 mb-sm-0 toolbarfield"
          placeholder="Page Number"
          v-model="currentPage"
        ></b-input>
        <b-input v-else
          id="pageNumberStream"
          class="mb-2 mr-sm-2 mb-sm-0 toolbarfield"
          placeholder="Page Number"
          v-model="streamedPage"
          @change="pageChanged"
        ></b-input>
        <label class="mr-sm-2 mobile-device" for="totalPages">Of </label>
        <b-input
          id="totalPages"
          class="mb-2 mr-sm-2 mb-sm-0 toolbarfield mobile-device"
          placeholder="Total Pages"
          v-model="totalPages"
          readonly
        ></b-input>

        <button type="button" @click="gotoNextPage()" class="btn">
          <img src="/media/Angle-right.svg" />
        </button>
      </b-form>
    </b-row>
    <hr>
    <!--end toolbar-->
    <!--the document-->
    <b-row class="viewer-container" id="pdfviewercontainer">
      <b-overlay :show="streamPdf && isPageLoading" rounded="sm">
      <vue-pdf-embed v-if="!showAllPages & !streamPdf" :source="pdfData"  :page="currentPageNum" :width="zoomLevel * 10" ref="pdfRef" @password-requested="setPassword" @rendered="handleDocumentRender" :disableTextLayer="true"/>
      <vue-pdf-embed v-if="!showAllPages & streamPdf" :source="pdfData" :width="zoomLevel * 10" ref="pdfRef" @password-requested="setPassword" @rendered="handleDocumentRender" :disableTextLayer="true"/>
        
      <vue-pdf-embed v-if="showAllPages & !streamPdf" :source="pdfData" :width="zoomLevel * 10" ref="pdfRef" @password-requested="setPassword" @rendered="handleDocumentRender" :disableTextLayer="true"/>
      </b-overlay>
    </b-row>
      <b-row class="viewer-container mobile-device" v-if="!showAllPages && !streamPdf">
         
         <button type="button" @click="getPrevTen()" class="btn" v-if="showLoadMorePages">
           <img src="/media/Angle-left.svg" />
         </button>
                            <div v-for="page in pdfPages" :key="page" @click="goToPage(page)" class="viewer-pages" >
                                          <vue-pdf-embed  
                                          :source="pdfData"
                                          :page="page"
                                          class="pdfviewer"
                                          :width="50"
                                        />
                            </div>
                            
                            <button type="button" @click="getNextTen()" class="btn" v-if="showLoadMorePages">
                              <img src="/media/Angle-right.svg" />
                            </button>
                 
    </b-row>
  </div>
</template>
